
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {isAddButton?: boolean;  disabled?: boolean}

export function ButtonPopup({
  children,
  className,
  onClick,
  isAddButton,
  disabled,
  type = "button", // 👈 Aquí
  ...props
}: Props) {
  return (
    <button
      type={type}
      className={`h-10 w-full transition-colors items-center justify-center bg-zinc-600 shadow-sm shadow-zinc-700 active:shadow-none rounded-md duration-400 border hover:border-blue-700 hover:border-r-4 hover:border-b-2 active:border-r active:border-b active:border-t-2 active:border-l-4 active:bg-white active:text-black text-white active:font-extrabold ${className}`}
      onClick={(e) => {
        if (onClick) {
          onClick(e); // Llama a la función original si existe
        }
      }}
      {...props}
    >
      {children}
    </button>
  );
}


export default ButtonPopup;
